export default __webpack_public_path__ + "static/media/ad.1d6ac034.svg";